import { getCookies } from '@gumtree/shared/src/util/cookie-service';
import { CustomPurposeConsentNames, isCustomPurposeConsented } from '../gdpr/util';

export default async function initMicrosoftClarity(window: Window) {
    // Clarity snippet is now injected server-side in HTML. Client should only handle consent.

    // After init, determine consent and signal to Clarity
    const cookie = getCookies(decodeURIComponent(window.document.cookie));
    const isGdprConsented = isCustomPurposeConsented(
        cookie.OptanonConsent,
        CustomPurposeConsentNames.MicrosoftClarity,
    );
    const winWithClarity = window as Window & { clarity?: (...args: any[]) => void };
    // Poll for clarity before sending consent.
    // Originally only 3 attempts (0/200/400ms); widen the window to better match delayed snippet loading.
    let attempts = 0;
    const maxAttempts = 15; // 15 * 200ms ≈ 3 seconds

    const trySendConsent = () => {
        attempts += 1;
        if (typeof winWithClarity.clarity === 'function') {
            // console.log('winWithClarity.clarity------', isGdprConsented);
            winWithClarity.clarity('consent', isGdprConsented);
        } else if (attempts < maxAttempts) {
            window.setTimeout(trySendConsent, 200);
        }
    };

    trySendConsent();
}
